import React, { ReactNode } from 'react'
import { InfoIcon } from 'components/Icons'
import ModalWTN, { ModalWtnProps } from '../ModalWTN'
import { useModalDispatch, useModalState, withModals } from 'hooks/use-modal'
import styles from './withInfoModal.module.scss'
import { WtnColorsEnum } from 'types/global'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

interface WithInfoModalProps {
  children: ReactNode
  widgetElId: ModalWtnProps['widgetElId']
  modalHeaderText: ModalWtnProps['textHeader']
  modalAcceptBtnText: string
  iconColor?: WtnColorsEnum
  wrapperClass?: string
  triggerClass?: string
  modalWrapperClass?: string
  withBtnsDivider?: boolean
}

const withInfoModal = (modalId: string, Component): ((props: WithInfoModalProps) => JSX.Element) =>
  withModals(
    ({
      wrapperClass,
      triggerClass,
      modalWrapperClass,
      iconColor = WtnColorsEnum.GRAY,
      ...props
    }: WithInfoModalProps) => {
      const { t } = useTranslation('strCommonUI')
      const { modalActions, modalDispatch } = useModalDispatch(modalId as never)
      const { isOpen } = useModalState(modalId as never)

      return (
        <div className={classNames(styles.container, wrapperClass)}>
          <Component />
          <button
            className={classNames(styles.modalTrigger, triggerClass)}
            onClick={() => modalDispatch(modalActions.openModal())}
            aria-label={t('ariaLabel.moreInfo')}
            aria-expanded={isOpen}
          >
            <InfoIcon color={iconColor} aria-hidden />
          </button>
          <ModalWTN
            {...props}
            modalId={modalId}
            btnAlignment='right'
            btnSecondary={{
              text: props.modalAcceptBtnText,
              onClick: () => {
                modalDispatch(modalActions.closeModal())
              },
            }}
            textHeader={props.modalHeaderText}
            className={modalWrapperClass}
          >
            {props.children}
          </ModalWTN>
        </div>
      )
    },
    {
      modals: {
        [modalId]: {
          isOpen: false,
        },
      },
    }
  )

export default withInfoModal
